import React from 'react';

import styles from "../styles/entity-mega-header-module.module.scss";
import classNames from "classnames";
import {ENTITY_MEGA_HEADER} from "../entity-mega-header-module.consts";
import {TOOLTIP_PLACEMENT} from "../../../../../core/components/tooltip/tooltip-consts";
import {Tooltip} from "../../../../../core/components/tooltip/tooltip";
import {Link} from "../../../../../core/components/link/link";
import {ACTION_TYPES} from "../../../../../core/consts";
import {APP} from "../../../../../core/app/consts";
import {observer} from "mobx-react";

export const EntityMegaHeaderModuleDescriptionTooltip = observer(({controller, entity, descriptionHeader}) => {
  const {state, device} = controller;
  const {isGameRoute, currentLinkModel} = state;
  const {isRtl} = device;

  const onEntityClick = () => {
    controller.action(ACTION_TYPES.entityClick, {
      entityId: entity?.id,
      entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[entity?.objectType],
      source: APP.ANALYTICS.SOURCES[currentLinkModel?.name],
      currentLinkModel: currentLinkModel?.name,
      sportTypeId: entity.sport.id
    });

    return true;
  }

  const linkProps = {
    model: entity.linkModel,
    onClick: () => onEntityClick()
  }

  const tooltipProps = {
    title: descriptionHeader?.description,
    placement: isRtl ? TOOLTIP_PLACEMENT.bottomStart : TOOLTIP_PLACEMENT.bottomEnd,
    maxWidth: ENTITY_MEGA_HEADER.DESCRIPTION_TOOLTIP_WIDTH,
  }

  const TitleTag = isGameRoute ? 'h2' : 'h1';

  return (
    <Tooltip {...tooltipProps}>
      <Link {...linkProps}>
        <TitleTag className={classNames(styles.title)}>
          {descriptionHeader?.title}
        </TitleTag>
      </Link>
    </Tooltip>
  )
});
